import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";

import { transition } from "../../utils/transition";
import { theme } from "../../theme/css/theme.css";
import { transitionDurations } from "../../theme";

export const containerBaseStyle = style({
  // keep
});

export const containerStyle = recipe({
  base: {
    position: "relative",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    selectors: {
      // [`${carouselStyle} &`]: {
      //   width: rem(300),
      //   aspectRatio: "4/3",
      // },
      "&:after": {
        transition: transition("outline"),
        content: "''",
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        outlineOffset: "-1px",
        outline: `1px solid rgba(0, 0, 0, 0)`,
      },
    },
  },
  variants: {
    borderRadius: {
      true: {
        borderRadius: theme.borderRadiuses.s,
        selectors: {
          "&:after": {
            borderRadius: theme.borderRadiuses.s,
          },
        },
      },
    },
    hover: {
      true: {
        cursor: "pointer",
        selectors: {
          "&:hover:after": {
            outlineColor: theme.colors.primary,
          },
        },
      },
    },
    forceHover: {
      true: {
        selectors: {
          "&:after": {
            outlineWidth: "2px",
            outlineOffset: "-2px",
            outlineColor: `${theme.colors.primary} !important`,
          },
        },
      },
    },
    columns: {
      one: {
        gridColumn: "span 1",
      },
      two: {
        gridColumn: "span 2",
      },
    },
    outline: {
      true: {
        selectors: {
          "&:after": {
            outlineColor: "rgba(0, 0, 0, 0.1)",
          },
        },
      },
    },
  },
});

export const imageStyle = recipe({
  base: {
    transition: transition(
      {
        property: "opacity",
        duration: `${transitionDurations.s}s`,
      },
      {
        property: "transform",
        duration: `${transitionDurations.m}s`,
      },
    ),
    transform: "scale(1)",
    width: "100%",
    height: "100%",
    display: "block",
    position: "absolute",
    top: 0,
    left: 0,
    userSelect: "none",
  },
  variants: {
    hover: {
      true: {
        selectors: {
          [`${containerBaseStyle}:hover &`]: {
            transform: "scale(1.05)",
          },
        },
      },
    },
    forceHover: {
      true: {},
      false: {},
    },
    borderRadius: {
      true: {
        borderRadius: theme.borderRadiuses.s,
      },
      false: {},
    },
    fit: {
      cover: {
        objectFit: "cover",
      },
      contain: {
        objectFit: "contain",
      },
    },
    loading: {
      true: {
        opacity: 0,
      },
      false: {
        opacity: 1,
      },
    },
    autoHeight: {
      true: {
        height: "auto",
      },
    },
    filter: {
      grayscale: {
        filter: "grayscale(100%)",
      },
      none: {},
    },
    position: {
      center: {
        objectPosition: "center",
      },
      top: {
        objectPosition: "top",
      },
      bottom: {
        objectPosition: "bottom",
      },
      left: {
        objectPosition: "left",
      },
      right: {
        objectPosition: "right",
      },
    },
  },
  defaultVariants: {
    fit: "cover",
  },
});

export const iconStyle = style({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
});
